const angular = require('angular');
const app = angular.module('learn-directives');

import React from 'react';
import { createRoot } from 'react-dom/client';
import ViewSurveyLayout from '../view-survey-app';

const layoutVars = {
  survey: null,
  surveyResults: null,
  companyBranding: null,
  completeFn: null,
  partialCompleteFn: null,
};

function renderLayout(root, layoutVars) {
  const allPropsLoaded = !!(
    layoutVars.survey &&
    layoutVars.surveyResults &&
    layoutVars.companyBranding &&
    layoutVars.completeFn &&
    layoutVars.partialCompleteFn
    );
  root.render(
    <div>
      { 
        allPropsLoaded &&
        <ViewSurveyLayout
          survey={layoutVars.survey}
          surveyResults={layoutVars.surveyResults}
          companyBranding={layoutVars.companyBranding}
          completeFn={layoutVars.completeFn}
          partialCompleteFn={layoutVars.partialCompleteFn}
        />
      }
    </div>
  );
}

const viewSurveyDirective = app.directive('viewSurveyDirective', [
  function () {
    return {
      template: `<div id="view-survey-app" class="react-part"></div>`,
      scope: {
        survey: '=',
        surveyResults: '=',
        companyBranding: '<',
        completeFn: '=',
        partialCompleteFn: '=',
      },
      link: function (scope, el, attrs) {
        const reactapp = document.getElementById("view-survey-app");
        const root = createRoot(reactapp);
        scope.$watch(
          'survey',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.survey = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'surveyResults',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.surveyResults = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );
        
        scope.$watch(
          'companyBranding',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.companyBranding = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'completeFn',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.completeFn = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'partialCompleteFn',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.partialCompleteFn = newVal;
              renderLayout(root, layoutVars);
            }
          },
          true
        );
      },
    };
  },
]);

export default viewSurveyDirective;